import React from "react";
import PropTypes from "prop-types";
import {
  buildEmbedStylesheet,
  resolveEmbedClasses,
} from "./ElementEmbedStyleResolver";

const ElementEmbed = (props) => {
  let element = props.element;
  const classes = resolveEmbedClasses(element);
  const stylesheet = buildEmbedStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );
  const embedCTAId = element.options["embed-cta-id"];
  const websiteId = element.website_id;
  const parentStepId =
    element.step_id || props.section?.step_id || props.step?.id;
  const selfEmbed = embedCTAId && String(embedCTAId) === String(props.cta.id);
  const websiteData = props.website?.data || {};

  return (
    <React.Fragment>
      <div className={classes}>
        {props.builder !== true && embedCTAId && !selfEmbed && (
          <div className="cf-embed" id={`cf-embed-${element.id}`}>
            <div
              className={`cf-cta-snippet cta${embedCTAId}`}
              data-website-id={websiteId}
              data-cta-id={embedCTAId}
              data-parent-cta-id={`${props.cta.id}`}
              data-parent-variant-id={`${props.variant.id}`}
              data-parent-step-id={parentStepId ? `${parentStepId}` : undefined}
              data-parent-element-id={`${props.element.id}`}
            ></div>
            {websiteData["site-heading-font-family"] &&
              websiteData["site-heading-font-url"] && (
                <link
                  rel="stylesheet"
                  href={websiteData["site-heading-font-url"]}
                />
              )}
            {websiteData["site-paragraph-font-family"] &&
              websiteData["site-paragraph-font-url"] && (
                <React.Fragment>
                  {websiteData["site-paragraph-font-url"] !==
                    websiteData["site-heading-font-url"] && (
                    <link
                      rel="stylesheet"
                      href={websiteData["site-paragraph-font-url"]}
                    />
                  )}
                  <style
                    dangerouslySetInnerHTML={{
                      __html: `
                  #cf-embed-${element.id} .cf-element,
                  #cf-embed-${element.id} .cf-element div,
                  #cf-embed-${element.id} .cf-element p:not(.empty-container),
                  #cf-embed-${element.id} .cf-element span:not(.select-label-span),
                  #cf-embed-${element.id} .cf-element button,
                  #cf-embed-${element.id} .cf-element input,
                  #cf-embed-${element.id} .cf-element select,
                  #cf-embed-${element.id} .cf-element label {
                    font-family: '${websiteData["site-paragraph-font-family"]}', sans-serif;
                  }`,
                    }}
                  />
                </React.Fragment>
              )}
          </div>
        )}
        {props.builder == true && (
          <div className="element-content cf-embed-placeholder">
            <img
              src="/images/convertflow-icon-new.svg"
              alt="ConvertFlow"
              style={{
                width: "50px",
                height: "auto",
                margin: "0 auto 10px auto",
                display: "block",
              }}
            />
            <p style={{ fontSize: "14px" }}>
              Embed:{" "}
              <em>
                {embedCTAId
                  ? props.website?.ctas?.[embedCTAId]?.name ||
                    `Campaign ${embedCTAId}`
                  : "No campaign selected"}
              </em>
            </p>
          </div>
        )}
        <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
      </div>
    </React.Fragment>
  );
};

export default ElementEmbed;
